import { WhitePaper } from '@models/whitePaper';
import { ArticleEntityAdminService } from './articleEntityAdminService';

export class WhitePaperAdminService extends ArticleEntityAdminService<WhitePaper> {
    constructor() {
        super('/api/admin/white-paper');
    }
}
